/**
 * Asynchronously loads the component for ProfilePage
 */

import loadable from 'utils/loadable';

export default loadable(() => import('./ProfilePage.js'));
